import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  DropDownWithButton,
  TextInputField,
  TextInputFieldArea,
} from "../../../common-components";
import ImageUploadAWS from "../image-upload/ImageUploadAWS";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const UserPostRequestModal = ({
  display,
  onCancelClick,
  height,
  setPostRequestModal,
  auth,
  setRefresh,
  refresh,
  setMessage,
  setPopUpTitle,
  setToastPop,
  setLoading,
}) => {
  const [selectedPostType, setSelectedPostType] = useState(
    "CLICK HERE TO SELECT A POST TYPE"
  );

  const [subSelectionPostType, setSubSelectionPostType] = useState(
    "CLICK HERE TO SELECT A POST GROUP"
  );

  const [title, setTitle] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [sourceLink, setSourceLink] = useState("");
  const [tags, setTags] = useState("");
  const [imageData, setImageData] = useState(null);

  const [file, setFile] = useState(null);

  const [imageError, setImageError] = useState("");

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  const ReturnPostSubType = () => {
    if (selectedPostType === "BOLO") {
      return ["STOLEN VEHICLE", "HIJACKING", "MISSING PERSON", "KIDNAPPING"];
    } else if (selectedPostType === "WEATHER") {
      return [
        "HEAVY RAIN",
        "STRONG WINDS",
        "SNOW | HAIL",
        "HIGH | LOW TEMPERATURE",
      ];
    } else if (selectedPostType === "TRAFFIC") {
      return [
        "SLOW TRAFFIC",
        "ACCIDENT",
        "ROAD CLOSURE",
        "PROTEST | LOOTING | HEIST",
      ];
    } else if (selectedPostType === "VEHICLE") {
      return ["VEHICLE LAUNCH", "SALE", "RECALL", "AFTER MARKET PRODUCTS"];
    } else {
      return ["ANNOUNCEMENTS", "EVENTS"];
    }
  };

  const ClearData = () => {
    setSelectedPostType("CLICK HERE TO SELECT A POST TYPE");
    setTitle("");
    setShortDescription("");
    setLongDescription("");
    setSourceLink("");
    setTags("");
    setSubSelectionPostType("CLICK HERE TO SELECT A POST GROUP");
  };

  const CreateTagsArray = () => {
    const TagsArray = tags.split(" ");
    return TagsArray;
  };

  const CreatenewPost = async (e) => {
    setLoading(true);

    if (!validFileTypes.find((type) => type === file.type)) {
      setImageError("File type must be JPG or PNG format");
      return;
    } else {
      setImageError("");
      setImageData(file);
    }
    try {
      const postArray = [`${selectedPostType}`, `${subSelectionPostType}`];
      const formData = new FormData();
      formData.append("image", file);
      formData.append("title", title);
      formData.append("senderId", auth.customerUserData.userId);
      formData.append(
        "senderDetails",
        auth.customerUserData.firstName + " " + auth.customerUserData.lastName
      );
      formData.append("status", "PENDING");
      formData.append("shortDescription", longDescription.substring(0, 50));
      formData.append("longDescription", longDescription);
      formData.append("postType", postArray);
      formData.append("tags", CreateTagsArray());
      formData.append("sourceLink", sourceLink);
      formData.append("creationApprovedBy", "None");
      formData.append(
        "editedBy",
        auth.customerUserData.firstName + " " + auth.customerUserData.lastName
      );

      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/buzzPost/createPost",
        {
          method: "POST",
          body: formData,
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setPostRequestModal(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setRefresh(refresh ? false : true);
        ClearData();
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };
  useEffect(() => {
    setSubSelectionPostType("CLICK HERE TO SELECT A POST GROUP");
  }, [selectedPostType]);
  return (
    <div
      style={{
        position: "absolute",
        height: display ? "100%" : 0,
        width: "100%",
        overflowY: "hidden",
        overflowX: "hidden",
        backgroundColor: colors.white,
        bottom: 0,
        transition: "all 0.3s",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 300,
        maxHeight: height,
      }}
    >
      <div
        style={{
          textAlign: "center",
          width: "100%",
          fontSize: 28,
          fontWeight: "bold",
          color: colors.greenDark,
          // marginBottom: 10,
          marginTop: 20,
        }}
      >
        BUZZ NOTICE
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
          // marginBottom: 40,
          minHeight: 300,
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {/* <div style={{ padding: height > 650 ? 40 : 80 }} /> */}
        <DropDownWithButton
          data={["BOLO", "WEATHER", "TRAFFIC", "VEHICLE", "GENERAL"]}
          title={selectedPostType}
          setSelectedItem={setSelectedPostType}
          width={300}
        />
        {selectedPostType !== "CLICK HERE TO SELECT A POST TYPE" ? (
          <DropDownWithButton
            data={ReturnPostSubType()}
            title={subSelectionPostType}
            setSelectedItem={setSubSelectionPostType}
            width={300}
          />
        ) : null}

        <div style={{ marginTop: 20 }} />
        <TextInputField
          labelTitle={"TITLE"}
          mini={true}
          count={50}
          reqiredCheck={true}
          rule={0}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <div style={{ height: 10 }} />
        <TextInputField
          labelTitle={"GOOGLE MAPS LOCATION"}
          mini={true}
          // count={50}
          // reqiredCheck={true}
          // rule={0}
          value={sourceLink}
          onChange={(e) => setSourceLink(e.target.value)}
        />
        <div style={{ height: 10 }} />

        <TextInputFieldArea
          labelTitle={"DESCRIPTION"}
          mini={true}
          count={150}
          reqiredCheck={true}
          rule={longDescription.length}
          height={150}
          value={longDescription}
          onChange={(e) => setLongDescription(e.target.value)}
        />
        <TextInputField
          labelTitle={"TAGS"}
          mini={true}
          count={50}
          reqiredCheck={true}
          rule={0}
          value={tags}
          onChange={(e) => setTags(e.target.value)}
        />
        <ImageUploadAWS
          onChange={(e) => handleFileChange(e)}
          labelTitle={"UPLOAD IMAGE"}
          mini={true}
          errorDisplay={imageError}
        />
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <BaseButtons
            label={"CANCEL"}
            width={"40%"}
            borderRadius={8}
            backgroundColor={colors.orangeDark}
            onClick={() => {
              ClearData();
              setPostRequestModal(false);
            }}
          />

          <div style={{ width: 20 }} />
          <BaseButtons
            label={"SUBMIT"}
            width={"40%"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            onClick={() => CreatenewPost()}
          />
        </div>
      </div>
    </div>
  );
};

export default UserPostRequestModal;
